import { Controller } from "stimulus"

export default class extends Controller {
  
  linkTo(e) {
    if (e.target.tagName !== "A")
      window.location = e.currentTarget.dataset.link
  }
}